// File: src/App.js
// This is the definitive version that fixes the "stuck loading" screen.
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import axios from 'axios';
import HomePage from './pages/HomePage';
import AdminDashboard from './pages/AdminDashboard';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import ManageContentPage from './pages/ManageContentPage';
import SeoManagementPage from './pages/SeoManagementPage';
import SettingsPage from './pages/SettingsPage';
import UnderConstructionPage from './pages/UnderConstructionPage';
import ContentViewPage from './pages/ContentViewPage';
import NewsletterPage from './pages/NewsletterPage';
import UserDashboardPage from './pages/UserDashboardPage';
import UserSettingsPage from './pages/UserSettingsPage';
import ProtectedRoute from './components/ProtectedRoute'; // Import the ProtectedRoute
import './index.css';

function App() {
  const [siteSettings, setSiteSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const [userSettings, setUserSettings] = useState({
    unitSystem: 'metric',
    waterGoal: 2000,
  });

  useEffect(() => {
    // Define a complete default structure for settings to prevent errors.
    const defaultSettings = {
        isOffline: false,
        socialLinks: {
            facebook: { url: '', isActive: false },
            instagram: { url: '', isActive: false },
            x: { url: '', isActive: false },
            tiktok: { url: '', isActive: false },
            youtube: { url: '', isActive: false },
        },
        integrations: {
            googleAnalyticsId: '',
            googleTagManagerId: '',
            googleSearchConsoleId: '',
            youtubeApiKey: '',
            adSenseId: '',
            reCaptchaKey: ''
        },
        monetization: {
            affiliateLink: ''
        }
    };

    const fetchSettings = async () => {
      try {
        const response = await axios.get(`/api/settings?_=${new Date().getTime()}`);
        // THE CRITICAL FIX: Merge the fetched settings into the default structure.
        // This guarantees that all keys are present, even if the DB record is old or incomplete.
        setSiteSettings({ ...defaultSettings, ...response.data });
      } catch (error) {
        console.error("Error fetching site settings:", error);
        setSiteSettings(defaultSettings); // Fallback to the default structure on error
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const [existingContent, setExistingContent] = useState([
    { id: 1, type: 'Video', title: 'New 10-Minute HIIT Workout', date: '2025-07-26', category: 'HIIT', slug: 'new-10-minute-hiit-workout', description: 'A quick and intense workout to get your heart pumping.', status: 'Published' },
    { id: 2, type: 'Article', title: '5 Healthy Meal Prep Ideas', date: '2025-07-25', category: 'Nutrition', slug: '5-healthy-meal-prep-ideas', description: 'Simple and delicious meal prep recipes for the week.', status: 'Published' },
  ]);
  
  if (loading) {
    return <div className="min-h-screen bg-black flex items-center justify-center text-white text-2xl">Loading...</div>;
  }

  return (
    <Router>
      <div className="bg-black text-white">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={siteSettings.isOffline ? <UnderConstructionPage siteSettings={siteSettings} /> : <HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/articles/:slug" element={<ContentViewPage allContent={existingContent} />} />

          {/* User Routes */}
          <Route path="/dashboard" element={<UserDashboardPage userSettings={userSettings} />} />
          <Route path="/settings" element={<UserSettingsPage userSettings={userSettings} setUserSettings={setUserSettings} />} />

          {/* Protected Admin Routes */}
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute><SettingsPage siteSettings={siteSettings} setSiteSettings={setSiteSettings} /></ProtectedRoute>} />
          <Route path="/admin/content" element={<ProtectedRoute><ManageContentPage siteSettings={siteSettings} existingContent={existingContent} setExistingContent={setExistingContent} /></ProtectedRoute>} />
          <Route path="/admin/seo" element={<ProtectedRoute><SeoManagementPage /></ProtectedRoute>} />
          <Route path="/admin/newsletter" element={<ProtectedRoute><NewsletterPage /></ProtectedRoute>} />
          
          {/* Catch-all for any other route */}
          <Route path="/*" element={siteSettings.isOffline ? <UnderConstructionPage siteSettings={siteSettings} /> : <HomePage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;




